import LoginSocialFacebook from './LoginSocial/Facebook.jsx';
import LoginSocialTwitter from './LoginSocial/Twitter.jsx';

export default () => {
  const $form = $('.js-loginModal__form')


  if ( !$form.length ) {
    return
  }


  const $modalBody = $('.js-loginModal__body');
  (new LoginSocialFacebook($form, $modalBody)).init();
  (new LoginSocialTwitter($form, $modalBody)).init();

  const $emailInput = $('.js-loginModal__input--email')
  const $passwordInput = $('.js-loginModal__input--password')

  $form.on('submit', submitForm)

  function submitForm(e) {
    e.preventDefault()

    const emailValue = $emailInput.val()
    const passwordValue = $passwordInput.val()
    // eslint-disable-next-line
    const url = lrg_login.ajaxurl
        // eslint-disable-next-line
    const nonce = lrg_login.ajaxnonce
    const data = {
      action: 'lrg_member_login',
      nonce_ajax : nonce,
      email: emailValue,
      password: passwordValue,
    }

    $modalBody.addClass('is-loading')
    $modalBody.append('<div class="c-loginModal__spinner js-loginModal__spinner l-spinner"><div class="l-spinner__el"></div></div>')

    $.post(url, data, function(response) {
      let errors = ''
      if ( response ) {
        try {
          const respData = JSON.parse(response);
          if ( respData.errors && respData.errors.length ) {
            errors = respData.errors[0]
          }
          console.log(respData, respData.errors)
          if ( respData.value === '1' || respData.value === 1 ) {
            if ( $form.attr('data-redirect') ) {
              window.location.href = $form.attr('data-redirect')
            } else {
              window.location.href = '/account/summary'
            }
          }
        }
        catch(e) {
          console.log('error', e)
        }
      }

      if ( errors ) {
        $('.js-loginModal__errorPlaceholder').text(errors)
      }
    })
    .always(function() {
      $('.js-loginModal__spinner').remove()
    })

  }

  $form.on('click', '.js-loginModal__btn--remind', resetPassword)

  function resetPassword(e) {
    e.preventDefault()

    const emailValue = $emailInput.val()
    // eslint-disable-next-line
    const url = lrg_login.ajaxurl
    // eslint-disable-next-line
    const nonce = lrg_login.ajaxnonce
    const data = {
      action: 'lrg_member_reset_password',
      nonce_ajax : nonce,
      email: emailValue,
    }

    $modalBody.addClass('is-loading')
    $modalBody.append('<div class="c-loginModal__spinner js-loginModal__spinner l-spinner"><div class="l-spinner__el"></div></div>')

    $.post(url, data, function(response) {
      let errors = ''
      if ( response ) {
        try {
          const respData = JSON.parse(response);
          if ( respData.errors && respData.errors.length ) {
            errors = respData.errors[0]
          }
          console.log(respData, respData.errors)
          if ( respData.value === '1' || respData.value === 1 ) {
            $('.js-loginModal__remindPassText')
              .text('We will email you a link to reset your password.')
              .addClass('success');
          }
        }
        catch(e) {
          console.log('error', e)
        }
      }

      if ( errors ) {
        $('.js-loginModal__errorPlaceholder').text(errors)
      }
    })
    .always(function() {
      $('.js-loginModal__spinner').remove()
    })
  }

  if(window.location.hash.match(/^#\/login\/?/)) {
    $('.c-loginModal').modal('show');
  }

  document.querySelector('.js-loginModal__close').addEventListener('click', function() {
    $('#c-loginModal').modal('hide')
  });

}
